<template>
    <div
        v-gtm:page="'K_TC'"
        class="tournamentCenter"
    >
        <TournamentNavbar />
        <RouterView />
    </div>
</template>

<script lang="ts" setup>
    import TournamentNavbar from '@/components/tournamentCenter/TournamentNavbar.vue';
</script>

<style lang="scss" scoped>
    @import "@/views/TournamentCenter";
</style>
